import { CharStatus } from "../../lib/statuses";
import classnames from "classnames";

type Props = {
  status: CharStatus;
};

export const MiniCell = ({ status }: Props) => {
  const classes = classnames(
    "w-10 h-10 flex items-center justify-center mx-0.5",
    {
      "bg-slate-400 dark:bg-slate-600": status === "absent",
      "cell-correct": status === "correct",
      "cell-present": status === "present",
    }
  );

  return <div className={classes}></div>;
};
